export const COMETCHAT_CONSTANTS = {
  APP_ID: process.env.REACT_APP_COMET_APP_ID,
  REGION: process.env.REACT_APP_COMET_REGION,
  AUTH_KEY: process.env.REACT_APP_COMET_AUTH_KEY,
};
